import React from 'react';
import { CheckAccordionRow } from '../CheckAccordionRow';
import { useAppSelector } from '../../../app/hooks';
import { selectNamecheck } from '../../../app/slices/report.slice';
import { useAppFeature } from '../../../hooks/useAppFeature';
import { AppFeature } from '../../../types/check/flags';
import { ItemStatus } from '../../../types/constants';

type IDCheckComponentProps = {
	onCommentClick: (...args: any[]) => void;
	onInfoClick: (...args: any[]) => void;
};

const IDCheckComponent = ({ onCommentClick, onInfoClick }: IDCheckComponentProps) => {
	const reportCommentTextIDCheck = useAppSelector((state) => state.ui.reportCommentTextIDCheck);
	const isUserAssessmentEnabled = useAppFeature(AppFeature.ASSESSMENT_USER_INPUT);
	const namecheck = useAppSelector(selectNamecheck);

	if (!namecheck) return <></>;

	const isVerified = isNamecheckVerified(namecheck);
	const indicatorColor = getNamecheckIndicatorColor(isVerified);

	return (
		<CheckAccordionRow
			title="ID Check"
			displayDetails={false}
			openable={false}
			onCommentClick={onCommentClick}
			onInfoClick={() => onInfoClick(namecheck)}
			commentFull={reportCommentTextIDCheck?.length > 0}
			displayComment={isUserAssessmentEnabled}
			displayInfo={true}
			indicatorColor={indicatorColor}
			verified={isVerified ? ItemStatus.VERIFIED : ItemStatus.UNVERIFIED}
		/>
	);
};

export default IDCheckComponent;

const VERIFIED = 'verified';
const UNVERIFIED = 'unverified';

function isNamecheckVerified(namecheck: any) {
	const verified = namecheck.result;
	if (verified === undefined || verified === UNVERIFIED) return false;
	return verified === VERIFIED;
}

function getNamecheckIndicatorColor(isVerified: boolean) {
	return isVerified ? undefined : 'yellow';
}
